export default __webpack_public_path__ + "static/media/2.da4d6061.jpg";